export function SupportIcon({ className }: { className?: string }) {
    return (
        <svg
            className={className}
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 28H8C7.46957 28 6.96086 27.7893 6.58579 27.4142C6.21071 27.0391 6 26.5304 6 26V22C6 21.4696 6.21071 20.9609 6.58579 20.5858C6.96086 20.2107 7.46957 20 8 20H12V28ZM12 28C12 28.5304 12.2107 29.0391 12.5858 29.4142C12.9609 29.7893 13.4696 30 14 30H18M24 28H28C28.5304 28 29.0391 27.7893 29.4142 27.4142C29.7893 27.0391 30 26.5304 30 26V22C30 21.4696 29.7893 20.9609 29.4142 20.5858C29.0391 20.2107 28.5304 20 28 20H24V28Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M24 20C24 16.8174 22.7357 13.7652 20.4853 11.5147C18.2348 9.26428 15.1826 8 12 8C8.8174 8 5.76516 9.26428 3.51472 11.5147C1.26428 13.7652 0 16.8174 0 20"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(6, 0)"
            />
        </svg>
    );
}
